<template>
    <iframe
        style="width: 100%; border: none; min-height: 1000px"
        referrerpolicy="no-referrer"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
        loading="lazy"
        importance="low"
        :src="blobUrl"></iframe>
</template>

<script setup lang="ts">
    const props = defineProps<{ html: string }>();
    const blobUrl = ref('');

    onMounted(() => {
        // Wrap the HTML in a simple document that preserves iframe functionality
        // but prevents it from affecting parent history
        const wrappedHtml = `
    <!DOCTYPE html>
    <html>
      <head>
        <base target="_self">
      </head>
      <body>${props.html}</body>
    </html>
  `;

        // Create a Blob with the HTML content
        const blob = new Blob([wrappedHtml], { type: 'text/html' });

        // Create a URL for the Blob (this creates a completely separate origin)
        blobUrl.value = URL.createObjectURL(blob);
    });

    // Clean up the Blob URL when component is unmounted
    onBeforeUnmount(() => {
        if (blobUrl.value) {
            URL.revokeObjectURL(blobUrl.value);
        }
    });
</script>
